import { Heading, HeadingProps } from '../heading/heading';

export function Subtitle(props: HeadingProps): JSX.Element {
  return (
    <Heading
      as="h2"
      {...props}
      marginY={0}
      variant="h4"
      color="palette_gray.60"
      textStyle="bodyCapital"
    />
  );
}
